import React from "react";
import styles from "./md-icon.scss";
export default function Edit24(props) {
    return (
        <div className={styles.view}>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m19.3 8.925-4.25-4.2 1.4-1.4a1.92 1.92 0 0 1 1.413-.575 1.92 1.92 0 0 1 1.412.575l1.4 1.4c.383.383.583.846.6 1.388a1.806 1.806 0 0 1-.55 1.387L19.3 8.925ZM17.85 10.4 7.25 21H3v-4.25l10.6-10.6 4.25 4.25Z" fill={props.color || "#FFFFFF"}/></svg>
        </div>
    );
};